import React, { useState } from 'react';
import Icons from './Icons';

function formatTimeAgo(dateString) {
  if (!dateString) return '';
  const seconds = Math.floor((new Date() - new Date(dateString)) / 1000);
  if (seconds < 60) return 'just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  if (seconds < 604800) return `${Math.floor(seconds / 86400)}d ago`;
  return new Date(dateString).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

const getPriorityStyles = (priority) => {
  switch (priority) {
    case 'urgent':
      return 'bg-danger-50 border-danger-300 text-danger-900';
    case 'important':
      return 'bg-warning-50 border-warning-300 text-warning-900';
    default:
      return 'bg-primary-50 border-primary-300 text-primary-900';
  }
};

const getPriorityIcon = (priority) => {
  switch (priority) {
    case 'urgent': return Icons.alertTriangle('w-5 h-5 flex-shrink-0 mt-0.5');
    case 'important': return Icons.bolt('w-5 h-5 flex-shrink-0 mt-0.5');
    default: return Icons.megaphone('w-5 h-5 flex-shrink-0 mt-0.5');
  }
};

const AnnouncementsBanner = ({ announcements, onMarkRead }) => {
  const [dismissedIds, setDismissedIds] = useState([]);

  if (!announcements || announcements.length === 0) return null;

  const visibleAnnouncements = announcements.filter(a => !dismissedIds.includes(a.id));

  if (visibleAnnouncements.length === 0) return null;

  const handleDismiss = (id) => {
    setDismissedIds(prev => [...prev, id]);
    onMarkRead(id);
  };

  return (
    <div className="space-y-3 mb-8">
      {visibleAnnouncements.map(announcement => (
        <div
          key={announcement.id}
          className={`border rounded-lg p-4 ${getPriorityStyles(announcement.priority)} relative`}
        >
          <div className="flex items-start justify-between">
            <div className="flex items-start space-x-3 flex-1 min-w-0">
              {getPriorityIcon(announcement.priority)}
              <div className="flex-1 min-w-0">
                <div className="flex items-center flex-wrap gap-2 mb-1">
                  <h4 className="font-semibold text-sm">{announcement.title}</h4>
                  {!announcement.is_read && (
                    <span className="bg-danger-500 text-white text-xs px-1.5 py-0.5 rounded-full font-medium">
                      New
                    </span>
                  )}
                  {announcement.is_pinned && (
                    <span className="flex items-center gap-1 text-xs opacity-60">
                      {Icons.pin('w-3 h-3')} Pinned
                    </span>
                  )}
                </div>
                <p className="text-sm opacity-80">{announcement.content}</p>
                <p className="text-xs opacity-50 mt-1">
                  {announcement.author_first_name} {announcement.author_last_name} · {formatTimeAgo(announcement.created_at)}
                </p>
              </div>
            </div>
            <button
              onClick={() => handleDismiss(announcement.id)}
              className="text-gray-400 hover:text-gray-600 ml-2 flex-shrink-0"
              aria-label="Dismiss"
            >
              {Icons.close('w-4 h-4')}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AnnouncementsBanner;
